export default "__VITE_ASSET__DLQ3BR_N__"